import { ref, readonly } from 'vue'

interface StackItem {
  fileId: string
  pageIndex: number
  startTime?: number
}

const fileStack = ref<StackItem[]>([])

export default function useOpenFileStack() {
  const pushToStack = (fileId: string, pageIndex: number, startTime?: number) => {
    fileStack.value.push({ fileId, pageIndex, startTime })
  }

  const popFromStack = (): StackItem | undefined => fileStack.value.pop()
  const resetStack = () => {
    fileStack.value = []
  }

  return {
    resetStack,
    pushToStack,
    popFromStack,
    fileStack: readonly(fileStack),
  }
}
